/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

import { ReduxReducer } from "../../../../interface";
import { Archive } from "../../interface";

import { State } from "./interface";

const initialState: State = {
	bankTransactions: {},
};

const setBankTransactions: ReduxReducer<State, State["bankTransactions"]> = (
	state,
	action,
) => {
	for (const [id, data] of Object.entries(action.payload)) {
		const numericId = Number(id);
		if (!Number.isNaN(numericId)) {
			state.bankTransactions[numericId] = data;
		}
	}

	// state.bankTransactions = action.payload;
};

const archivesBankTransactionsData = createSlice({
	name: Archive.ConstantOrderSlice.BANK_TRANSACTIONS_DATA,
	initialState,
	reducers: {
		setBankTransactions,
	},
});

export const archivesBankTransactionsDataAction =
	archivesBankTransactionsData.actions;
export const archivesBankTransactionsDataReducer =
	archivesBankTransactionsData.reducer;
export type archivesBankTransactionsDataState = State;

export default archivesBankTransactionsData;
